import Container = PIXI.Container;
import { SceneManager } from '../../core/managers/SceneManager';
import { addCounters, createButton } from '../../utils/GameEngine';
import { Button } from '../../UI/elements/buttons/Button';
import { AbstractWindow } from '../AbstractWindow';
import { WindowName } from '../../core/managers/WindowManager';
import { Events } from '../../core/Events';
import { SettingsButtonSquare } from '../../UI/elements/buttons/SettingsButtonSquare';
import { GameAnalytics } from '../../analytics/GameAnalytics';

export interface MainMenuParams {
  FTUE: boolean;
  goToLevel?: number;
}

export class MainMenu extends AbstractWindow {
  private UIButtons: Button[] = [];
  private continueButton: Button;

  constructor(name: WindowName, private params?: MainMenuParams) {
    super(name);
  }

  protected drawLayout(): void {
    //
  }

  private drawTopBar(): void {
    const topBar: Container = new Container();
    this.addChild(topBar);
    addCounters(this);

    const settingsButton: Button = new SettingsButtonSquare((): void => {
      dispatchEvent(new CustomEvent(Events.showSettings));
    });
    settingsButton.position.set(SceneManager.gameWidth - 84 / 2 - 32, SceneManager.buttonY);
    topBar.addChild(settingsButton);
    this.UIButtons.push(settingsButton);
  }

  public show(): void {
    this.checkFTUE(this.params.FTUE);
    super.show();
    this.UIButtons.forEach((button: Button) => {
      button.playAppearAnimation();
    });

    if (GameAnalytics.getInstance().isTester()) {
      FBInstant.player.canSubscribeBotAsync().then(
        (can_subscribe: boolean) => {
          console.log(can_subscribe);
          if (can_subscribe) {
            FBInstant.player.subscribeBotAsync().then((): void => {
                FBInstant.setSessionData({
                  subscribed: true
                });
              }
            ).catch((error: any) => {
              // Handle subscription failure
            });
          }
        }
      );
    }
  }

  private checkFTUE(FTUE: boolean): void {
    // if (FTUE) {
    //   // this.map.visible = false;
    //   this.onFTUE();
    // } else {
    //   logEvent(AnalyticsEventNames.main_menu_show, 1);
    // }
  }

  private onFTUE(): void {
    // setTimeout((): void => {
    //   this.showStoryIntro();
    // }, 13);
  }

  private drawBottomBar(): void {
    const bottomBar: Container = new Container();
    this.addChild(bottomBar);

    this.continueButton = createButton('green_btn_large@2x', this, this.continueStory.bind(this), 'CONTINUE', true, true, 1);
    this.continueButton.x = SceneManager.gameWidth / 2;
    this.continueButton.y = SceneManager.buttonY;

    // if (StoryProgressManager.getInstance().finishedStory()) {
    //   this.continueButton.visible = false;
    // }
  }

  private continueStory(): void {
    dispatchEvent(new CustomEvent(Events.continueStory));
    // logEvent(AnalyticsEventNames.main_menu_action, 1, {source: 'Continue'});
  }

}